var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoWidgetLive = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 18,
  y: 3,
  fill: "#FF1D1D",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m17 12-8 4V8z"
})));
export default SvgVideoWidgetLive;